<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link> /
        <router-link :to="{name: 'admin-master' }" class="root">
            Admin Master
        </router-link>
        <span class="child">/ Subject Tool</span>
    </v-row><br />
    <v-card class="card">
          <!-- <center class="heading"><h3>Subject Tool</h3></center> -->
  <v-card-title class="heading justify-center">
        <span>Subject Tool</span>
      </v-card-title>
      <v-card-text>
          <template v-if="lang_list!=null">
      <v-data-table :headers="headers" :items="lang_list" :search="search" class="elevation-1 nowrap">
        <template v-slot:top>
          <v-toolbar flat color="white">

            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search in table"
              single-line
              hide-details
            ></v-text-field>
           <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn class=" button" v-on="on">Add New Subject Tool</v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="heading">
                     Add New Subject Tool
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field  label="Name" v-model="defaultItem.name" placeholder="calculator"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-checkbox class="mx-2" v-model="defaultItem.isactive" label="Active"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="button-cancel" text @click="close">Cancel</v-btn>
                      <v-btn class="button" :loading="save_btn_load" text @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

          </v-toolbar>

        </template>
        



        <template v-slot:item.isactive="{ item }">
            <v-icon v-if="item.isactive==true" color="success" class="mr-2">mdi-check-circle-outline</v-icon>
            <v-icon v-else color="error" class="mr-2">mdi-close-circle-outline</v-icon>
        </template>
        <template v-slot:item.actions="{ item }">
         <!-- <v-btn :loading="edit_btn_load" @click="editItem(item)" class="link"  color="info"> <v-icon  title="Activate/Deactivate the Mode" >mdi-recycle</v-icon></v-btn> -->
         <v-switch v-model="item.isactive"  @change="editItem(item)"></v-switch>
        </template>
        <template v-slot:item.edit="{ item }">
          <div>
              <v-avatar style="" size="33" class="edit-avatar">
                  <v-icon class="edit-v-icon mr-2" size="18" @click="edit(item)">edit</v-icon>
              </v-avatar>
          </div>
          <!-- <v-icon small class="mr-2" @click="edit(item)">mdi-pencil</v-icon> -->
        </template>
      </v-data-table>
    </template>
      </v-card-text>
    </v-card>
    <div v-if="dialog_edit == true">
               <v-dialog v-model="dialog_edit" max-width="500px">
                  <v-card>
                    <v-card-title class="heading">Edit Subject Tool</v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field  label="Name" v-model="editedItem.name" placeholder="calculator"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-checkbox class="mx-2" v-model="editedItem.isactive" label="Active"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="button-cancel" text  @click="dialog_edit = false">Cancel</v-btn>
                      <v-btn class="button" :loading="save_btn_load" text @click="saveedit">Update</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
        </div>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    defaultItem:{
        isactive:true,
        name:"",
    },
    editedItem:{
        isactive:"",
        name:"",
        id:"",
    },
    dialog_edit:false,
    snackbar_msg: "",
    snackbar: false,
    color: "",
    org: null,
    search:'',
    edit_btn_load:false,
    dialog:false,
    //
    lang_list:null,
    headers: [
      { text: "Landuage", value: "name" },
      { text: "Acitve?", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Toggle", value: "actions", sortable: false }
    ],
  }),
  watch: {
    
  },
  methods: {
    edit(item){
        this.dialog_edit=true;
        this.editedItem.name=item.name
        this.editedItem.isactive=item.isactive
        this.editedItem.id=item.id;
    },
    saveedit(){
      if (this.editedItem.name == "" || this.editedItem.name == null) {
        this.showSnackbar("#b71c1c", "Please Add Tool Name!!!");
        return;
      }
      axios
          .post("/adminMaster/saveEditSubjectTool", this.editedItem)
          .then(res => {
            if (res.data.status == "YES") {
              this.showSnackbar("#4CAF50", "Subject Tool Edited Successfully.");
              this.lang_list = res.data.tool_list;
              this.dialog_edit=false
              //this.editedItem="";
            } else {
              this.showSnackbar("#b71c1c", "Subject Tool Not Found!!!");
              this.dialog_edit=false
               //this.editedItem="";
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          })
          .finally(() => {
            this.save_btn_load = false;
          });
    },

     save() {
      if (this.defaultItem.name == "" || this.defaultItem.name == null) {
        this.showSnackbar("#b71c1c", "Please Add Tool Name!!!");
        return;
      }
      axios
          .post("/adminMaster/saveSubjectTool", this.defaultItem)
          .then(res => {
            if (res.data.status == "YES") {
              this.showSnackbar("#4CAF50", "Subject Tool Added Successfully.");
              this.lang_list = res.data.tool_list;
              this.dialog=false
              this.defaultItem.name="";
            } else {
              this.showSnackbar("#b71c1c", "Subject Tool Already added!!!");
              this.dialog=false
               this.defaultItem.name="";
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          })
          .finally(() => {
            this.save_btn_load = false;
          });
     },
     close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item){
        console.log(item)
        this.edit_btn_load = true
        axios
        .post("/adminMaster/editstudentTool",item)
        .then(res => {
            this.lang_list = res.data.lang_list
            this.showSnackbar("#4CAF50","Success")
        })
        .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
            this.edit_btn_load = false
        axios
        });
    },
  },
  mounted() {
    axios
      .post("/adminMaster/studentTool")
      .then(res => {
          this.org = res.data.org
          this.lang_list = res.data.lang_list
         //this.showSnackbar("#4CAF50","Success")
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong!!!");
      })
      .finally(() => {

      });
  }
};
</script>